/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputPromotedProduct
 */
export interface InputPromotedProduct {
    /**
     * 
     * @type {string}
     * @memberof InputPromotedProduct
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InputPromotedProduct
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InputPromotedProduct
     */
    scores: string;
}

/**
 * Check if a given object implements the InputPromotedProduct interface.
 */
export function instanceOfInputPromotedProduct(value: object): value is InputPromotedProduct {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('scores' in value) || value['scores'] === undefined) return false;
    return true;
}

export function InputPromotedProductFromJSON(json: any): InputPromotedProduct {
    return InputPromotedProductFromJSONTyped(json, false);
}

export function InputPromotedProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputPromotedProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'scores': json['scores'],
    };
}

export function InputPromotedProductToJSON(json: any): InputPromotedProduct {
    return InputPromotedProductToJSONTyped(json, false);
}

export function InputPromotedProductToJSONTyped(value?: InputPromotedProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
        'scores': value['scores'],
    };
}

